import * as React from 'react';
import { IGroupedComboBoxSubMenuSection } from 'grouped-combobox-core';

export type RefreshSubmenuCallback = (newSections: IGroupedComboBoxSubMenuSection[]) => void;

export type GroupedComboBoxButtonContext = {
    refreshContainingMenu: RefreshSubmenuCallback;
};

export const SubmenuContext = React.createContext<GroupedComboBoxButtonContext>({
    refreshContainingMenu: () => {
        return;
    },
});

SubmenuContext.displayName = 'SubmenuContext';
